import PoetAllInfoVideo from './PoetAllInfoVideo.jsx';

import 'react-modal-video/scss/modal-video.scss';

export default PoetAllInfoVideo;
